import Component from "@tunnel-components/@sharded/masque/component";
import {
  GetZoneByIdCameraLoadedActionCreator,
  GetZoneByIdCameraResetActionCreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";

import * as React from "react";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }               state
     */
    this.state = { noImageUrl: true };
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ camera: null, target: null }));
    this.props.GetZoneByIdCameraResetActionCreator();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.camera !== this.props.camera) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ camera: nextProps.camera }));

      this.props.GetZoneByIdCameraLoadedActionCreator(nextProps.camera); // action creator
    } else if (nextProps.target !== this.props.target) {
      if (!Lodash.isUndefined(nextProps.target)) {
        const image = new Image();
        image.src = nextProps.target;

        if (image.width === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ noImageUrl: true }));
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ noImageUrl: false }));
        }
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ target: nextProps.target }));
    }
    //  this.props.virtualDomUpdate();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.camera !== this.props.camera) {
      this.props.GetZoneByIdCameraLoadedActionCreator(this.props.camera);
    } else if (prevProps.target !== this.props.target) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any) => ({ target: this.props.target }));
    }
    //  this.props.virtualDomUpdate();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.props.GetZoneByIdCameraLoadedActionCreator(this.props.camera);
    // this.props.virtualDomUpdate();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return <Component {...this.state} {...this.props} />;
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    masqueSource: state.GetZoneByIdCameraLoaded.data,
  };
}

export default connect(mapStateToProps, {
  GetZoneByIdCameraResetActionCreator,
  GetZoneByIdCameraLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/masque/container.tsx